import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '65a44abf-1953-412a-8c4b-eee87e435e69',
    authority: 'https://login.microsoftonline.com/b0b2fccb-34d4-48f8-b5b4-2c6223249699/',
    knownAuthorities: ['https://login.microsoftonline.com/', 'https://login.microsoftonline.com/b0b2fccb-34d4-48f8-b5b4-2c6223249699/'],
    redirectUri: 'http://localhost:3000',
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error: {
            console.error(message);
            break;
          }
          case LogLevel.Info: {
            console.info(message);
            break;
          }
          case LogLevel.Verbose: {
            console.debug(message);
            break;
          }
          case LogLevel.Warning: {
            console.warn(message);
            break;
          }
          default:
            break;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account',
  redirectUri: 'http://localhost:3000'
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};
